'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _botTypingStatesReduc;

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _setIn = require('transmute/setIn');

var _setIn2 = _interopRequireDefault(_setIn);

var _typingIndicatorActionTypes = require('../constants/typingIndicatorActionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.Map)();

var botTypingStatesReducer = (_botTypingStatesReduc = {}, _defineProperty(_botTypingStatesReduc, _typingIndicatorActionTypes.START_BOT_TYPING, function (state, action) {
  var _action$payload = action.payload,
      threadId = _action$payload.threadId,
      botId = _action$payload.botId;


  return (0, _setIn2.default)(['' + threadId, '' + botId], true, state);
}), _defineProperty(_botTypingStatesReduc, _typingIndicatorActionTypes.STOP_BOT_TYPING, function (state, action) {
  var _action$payload2 = action.payload,
      threadId = _action$payload2.threadId,
      botId = _action$payload2.botId;


  return state.deleteIn(['' + threadId, '' + botId]);
}), _botTypingStatesReduc);

exports.default = (0, _reduxActions.handleActions)(botTypingStatesReducer, initialState);
module.exports = exports['default'];